import { useEffect } from 'react';
import trash from '../../../../assets/img/svg/table/trash.svg';
import GeoFilters from './GeoFilters';
import OtherFilters from './OtherFilters';
import { t } from 'i18next';

import { useAllFilters } from '../../../../hook/useAllFilters';
import { useAppSelector } from '../../../../hook/useAppSelector';
import { Visibility } from '../../../../enum/Visibility';
import { useFilterDropdown } from '../../../../hook/useFilterDropdown';
import { closeFilterDropdown, openFilterDropdown } from '../../../../store/slice/filter-slice';
import { useAppDispatch } from '../../../../hook/useAppDispatch';

const HeaderFiltersSetup = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector((state) => state.globalFilters);
  const { handleApplyAllFilters } = useAllFilters();
  const openFilters = useAppSelector((state) => state.filters.openFilterDropDown);

  const {
    openDropdown,
    justClosed,
    toggleDropdown,
    updateFilters,
    setOpenDropdown,
    setJustClosed,
    handleResetFilters,
    isOpen,
  } = useFilterDropdown();

  useEffect(() => {
    if (!openFilters) {
      setOpenDropdown(null);
      setJustClosed(null);
    }
  }, [openFilters, setJustClosed, setOpenDropdown]);

  return (
    <div
      className={`filter_setup ${openFilters ? Visibility.VISIBLE : Visibility.HIDDEN} ${
        openDropdown ? 'expanded' : 'not_expanded'
      }`}
    >
      <div className="filter_header">
        <span className="title">{t('statisticPage.header.filter.filterSetup')}</span>
        <div
          data-pw="filterResetAll"
          className="reset_all"
          onClick={() => {
            handleResetFilters();
            dispatch(openFilterDropdown());
          }}
        >
          <img src={trash} alt="Reset all" />
          <span>{t('statisticPage.header.filter.resetAll')}</span>
        </div>
      </div>
      <hr />
      <div className="filter_controls">
        <GeoFilters
          toggleDropdown={toggleDropdown}
          isOpen={isOpen}
          filters={filters}
          setFilters={updateFilters}
          justClosed={justClosed}
        />
        <OtherFilters
          filters={filters}
          setFilters={updateFilters}
          justClosed={justClosed}
          toggleDropdown={toggleDropdown}
          isOpen={isOpen}
        />
        <button
          data-pw="filterApplyFilters"
          className="apply_filters"
          onClick={() => {
            handleApplyAllFilters();
            dispatch(closeFilterDropdown());
          }}
        >
          {t('statisticPage.header.filter.applyFilters')}
        </button>
      </div>
    </div>
  );
};

export default HeaderFiltersSetup;
